import {useNavigate} from "react-router-dom";
import "./Erreur404.scss";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCompass, faArrowLeft} from "@fortawesome/free-solid-svg-icons";

function Erreur404() {
    const navigate = useNavigate();

    return (
        <div className="body-erreur-page">
            <div className="erreur-card">
                <FontAwesomeIcon icon={faCompass} className="icon-404" />
                <h1 className="erreur404">404</h1>
                <h2>Page introuvable</h2>
                <h3>Nous sommes désolés, mais la page que vous recherchez n'existe pas ou a été déplacée.</h3>
                <button
                    className="btn-back-to-home"
                    onClick={() => navigate("/")}
                >
                    <FontAwesomeIcon icon={faArrowLeft} />
                    Retour à l'accueil
                </button>
            </div>
        </div>
    );
}

export default Erreur404;
